import React, { useState, useEffect } from 'react'
import ParentsHeader from '../../components/Header/ParentsHeader'
import parentsviewStyle from './ParentsViewPage.module.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import BackBar from '../../components/BackBar/BackBar'
import SideBar from '../../components/Sidebar/SideBar'
import Authorimage from '../../../assets/images/9780823454143.jpg'
import { IoLinkOutline } from "react-icons/io5";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useMediaQuery } from 'react-responsive';
import { GoGlobe } from "react-icons/go";
import { FaUser } from "react-icons/fa6";
import { Link } from "react-router-dom";
require('typeface-poppins')

export default function ParentsViewPage() {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const [openIndex, setOpenIndex] = useState(null); // state to track open accordion item, null means none are open
  const [eventData, setEventData] = useState([]);  // For storing event data
  const [showAllBooks, setShowAllBooks] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  // Decode base64 event_id
  const decodedEventId = atob(id);
  localStorage.setItem('event_id', decodedEventId);
  // API call to get event data and authors data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const eventResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_events.php?id=${decodedEventId}`);

        if (eventResponse.status !== 200) {
          throw new Error('Failed to fetch events');
        }

        const data = await eventResponse.data;


        if (data.success && Array.isArray(data.events)) {
          const updatedEvents = data.events.map(event => {
            let books = [];
            try {
              if (event.book_data && typeof event.book_data === 'string') {
                books = JSON.parse(event.book_data);
              } else if (Array.isArray(event.book_data)) {
                books = event.book_data;
              }
            } catch (error) {
              console.error("Error parsing book_data:", error);
            }

            return { ...event, books };
          });

          setEventData(updatedEvents);  // Set the updated event data state
        } else {
          throw new Error('Invalid events data');
        }
      } catch (error) {
        console.error("Error fetching event or author data:", error);
        // Redirect to home page if there's an error
        navigate('/');
      }
    };

    fetchData();
  }, [decodedEventId, navigate]);  // Dependency on `decodedEventId` to fetch the data when `decodedEventId` changes

  // Log eventData after it's updated
  // useEffect(() => {
  //   if (eventData.length > 0) {
  //     console.log("Event data is updated:", eventData[0].event_name);
  //   }
  // }, [eventData]);

  const handleToggle = (index) => {
    // Toggle between opening and closing the same accordion item
    setOpenIndex(openIndex === index ? null : index);
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === "0000-00-00 00:00:00") return "000";

    // Convert MySQL format to ISO-safe format
    const date = new Date(dateString.replace(" ", "T"));

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  };


  return (
    <>
      <ParentsHeader />
      <div className={parentsviewStyle.parentsviewPage}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            {isMobile ? (
              undefined
            ) : (
              <div className='col' style={{ maxWidth: '275px' }}>
                <SideBar eventId={decodedEventId} />
              </div>
            )}

            <div className="col">
              {isMobile ? (
                // Mobile Event View Wrap
                <div className={`${parentsviewStyle.mobileventviewWrap} mb-3`}>
                  <h2>Behind the Pages: Elliot Finch</h2>
                  <div className='row'>
                    <div className='col-7'>
                      <div className={`${parentsviewStyle.mobileventData} mb-2`}>
                        <h4>Start and End Date</h4>
                        <p>00/00/0000 - 00/00/0000</p>
                      </div>
                      <div className={`${parentsviewStyle.mobileventData} mb-2`}>
                        <h4>Event Details</h4>
                        <p>Grade K-6</p>
                      </div>
                    </div>
                    <div className='col-5'>
                      <div className={`${parentsviewStyle.mobileventData} mb-2`}>
                        <h4>Order by date:</h4>
                        <p>00/00/0000</p>
                      </div>
                      <div className={`${parentsviewStyle.mobileventData} mb-2`}>
                        <h4>Location</h4>
                        <p>Library</p>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12'>
                      <div className={parentsviewStyle.mobilnoteText}>
                        <h4> Notes </h4>
                        <p> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                          incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                          exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                // Desktop Event View Wrap
                <div className={`${parentsviewStyle.eventviewWrap} mb-3`}>
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="d-flex">
                        <div className="mb-4 me-5">
                          <h4 className={`${parentsviewStyle.eventviewtextOne} mb-0`}>Event Name</h4>
                          <p className={`${parentsviewStyle.eventviewsubText} mb-0`}>{eventData.length > 0 ? eventData[0].event_name : "Loading..."}</p>
                        </div>
                        <div className="mb-4">
                          <h4 className={`${parentsviewStyle.eventviewtextOne} mb-0`}>Start and End Date</h4>


                          {/* <p className={`${parentsviewStyle.eventviewsubText} mb-0`}>{eventData.length > 0 ? `${new Date(eventData[0].event_start_date).toISOString().slice(0, 10).replace(/-/g, '/')} - ${new Date(eventData[0].event_end_date).toISOString().slice(0, 10).replace(/-/g, '/')}` : "Loading..."}</p> */}

                          <p className={`${parentsviewStyle.eventviewsubText} mb-0`}>
                            {eventData.length > 0
                              ? `${formatDate(eventData[0].event_start_date)} - ${formatDate(eventData[0].event_end_date)}`
                              : "Loading..."}
                          </p>


                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className="col-xl-3 mb-3">
                      <label className={`${parentsviewStyle.eventviewLabel} form-label`}>Event Details</label>
                      <input type='text' className={`${parentsviewStyle.eventviewInput} form-control`} value={eventData.length > 0 ? eventData[0].event_detail : "Loading..."} placeholder='Grade: K - 5' disabled />
                    </div>
                    <div className="col-xl-3 mb-3">
                      <label className={`${parentsviewStyle.eventviewLabel} form-label`}>Location</label>
                      <input type='text' className={`${parentsviewStyle.eventviewInput} form-control`} value={eventData.length > 0 ? eventData[0].event_location : "Loading..."} placeholder='Library' disabled />
                    </div>
                    <div className="col-xl-3">
                      <label className={`${parentsviewStyle.eventviewLabel} form-label`}>Time</label>
                      <input type='text'
                        className={`${parentsviewStyle.eventviewInput} form-control`}
                        placeholder='9:30am - 11:00am'
                        // value={eventData.length > 0 ? `${new Date(eventData[0].event_start_date).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true })} - ${new Date(eventData[0].event_end_date).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true })}` : ''}

                        value={eventData.length > 0 ? `${eventData[0]?.event_start_time} - ${eventData[0]?.event_end_time}` : ''}
                        disabled />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-12'>
                      <div className={parentsviewStyle.eventmessageBox}>
                        <h5> Message for Parents </h5>
                        <p>
                          {eventData[0]?.event_notes ||
                            `Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
                          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
                          ipsum dolor sit amet.`}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {isMobile ? (
                <div className={parentsviewStyle.mobilauthorContentWrap}>
                  <div className='row mb-4'>
                    <div className='col-lg-12'>
                      <div className={`${parentsviewStyle.mobileventAccordion} accordion`} id="mobileventInfo">
                        <div className={`${parentsviewStyle.mobileventMainitem} accordion-item`}>
                          <h2 className="accordion-header">
                            <button className={`${parentsviewStyle.mobilauthorbuttonItem} ${openIndex === 0 ? '' : `collapsed`} accordion-button`} type="button" onClick={() => handleToggle(0)} aria-expanded={openIndex === 0 ? 'true' : 'false'} aria-controls="collapseOne">
                              <div className='row w-100 g-2'>
                                <div className='col-4'>
                                  <div className={`${parentsviewStyle.mobilauthorImage}`}>
                                    <img src={Authorimage} className='img-fluid' />
                                  </div>
                                </div>
                                <div className='col-8'>
                                  <div className={parentsviewStyle.mobilauthorCon}>
                                    <h5>Elliot Finch</h5>
                                    <p>Author & Illustrator</p>
                                    <div className='d-flex align-items-center'>
                                      <FaUser className={`${parentsviewStyle.mobilIcons} me-3`} />
                                      <GoGlobe className={`${parentsviewStyle.mobilIcons}`} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </button>
                          </h2>
                          <div id="collapseOne" className={`accordion-collapse collapse ${openIndex === 0 ? 'show' : ''}`} data-bs-parent="#mobileventInfo">
                            <div className={`${parentsviewStyle.mobilaccordionBody} accordion-body`}>
                              <div className={parentsviewStyle.mobilaccordmidData}>
                                <h4>Bio</h4>
                                <p> Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
                                  nvidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
                                </p>
                                <h4>Authors Note to Families</h4>
                                <p> Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
                                  invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam
                                  et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
                                  Lorem ipsum dolor sit amet.
                                </p>
                              </div>
                              <div className={parentsviewStyle.mobilaccordbottomData}>
                                <h5>Book List: Elliot Finch</h5>
                                <div className={parentsviewStyle.mobileSlideFrame}>
                                  <Swiper slidesPerView={3} spaceBetween={18} centeredSlides={true}>
                                    <SwiperSlide>
                                      <div className={parentsviewStyle.mobileSlideBox}>
                                        <div className={parentsviewStyle.mobileSlideImg}>
                                          <img src={Authorimage} className='img-fluid' />
                                        </div>
                                        <div className={parentsviewStyle.mobileSlideTextBox}>
                                          <h6>Merci Suarez Can't Dance</h6>
                                          <p>$17.99</p>
                                        </div>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                      <div className={parentsviewStyle.mobileSlideBox}>
                                        <div className={parentsviewStyle.mobileSlideImg}>
                                          <img src={Authorimage} className='img-fluid' />
                                        </div>
                                        <div className={parentsviewStyle.mobileSlideTextBox}>
                                          <h6>Cat Kid: Comic Club Influe..</h6>
                                          <p>$17.99</p>
                                        </div>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                      <div className={parentsviewStyle.mobileSlideBox}>
                                        <div className={parentsviewStyle.mobileSlideImg}>
                                          <img src={Authorimage} className='img-fluid' />
                                        </div>
                                        <div className={parentsviewStyle.mobileSlideTextBox}>
                                          <h6>Negative Cat</h6>
                                          <p>$17.99</p>
                                        </div>
                                      </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                      <div className={parentsviewStyle.mobileSlideBox}>
                                        <div className={parentsviewStyle.mobileSlideImg}>
                                          <img src={Authorimage} className='img-fluid' />
                                        </div>
                                        <div className={parentsviewStyle.mobileSlideTextBox}>
                                          <h6>Cat Kid: Comic Club Influe..</h6>
                                          <p>$17.99</p>
                                        </div>
                                      </div>
                                    </SwiperSlide>
                                  </Swiper>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={parentsviewStyle.authorContentWrap}>
                  <div className='row mb-4'>
                    <div className='col-lg-12'>
                      <div className={`${parentsviewStyle.eventAccordion} accordion`} id="eventInfo">
                        {eventData && Array.isArray(eventData) && eventData.length > 0 ? (
                          eventData.map((event, index) =>
                            event.books.map((book, bookIndex) => {
                              const authorId =
                                book?.authorData && typeof book.authorData === "object"
                                  ? Object.values(book.authorData)[0]
                                  : null;

                              return (
                                <div className={`${parentsviewStyle.eventMainitem} accordion-item mb-3`} key={bookIndex}>
                                  <h2 className="accordion-header">
                                    <button className={`${parentsviewStyle.authorbuttonItem} accordion-button ${openIndex === bookIndex ? `${parentsviewStyle.fulleventbgColor}` : 'collapsed'}`} type="button" onClick={() => handleToggle(bookIndex)} aria-expanded={openIndex === bookIndex ? 'true' : 'false'} aria-controls="collapseOne">
                                      <span className={parentsviewStyle.authorrightmargin}> Author Name <small className='ps-2'> {book.authorName} </small></span>
                                      <span> Title <small className='ps-2'> Author & Illustrator </small></span>
                                    </button>
                                  </h2>
                                  <div id="collapseOne" className={`accordion-collapse collapse ${openIndex === bookIndex ? 'show' : ''}`} data-bs-parent="#eventInfo">
                                    <div className={`${parentsviewStyle.accordionBody} accordion-body`}>
                                      <div className={`${parentsviewStyle.accordioninnerWrap} mb-3`}>
                                        <div className='d-flex align-items-start mb-4'>
                                          <div className='me-5'>
                                            <div className={`${parentsviewStyle.authorImageWrap} mb-2`}>

                                              <img src={authorId ? `${process.env.REACT_APP_API_BASE_URL}authormeetapi/images/author/${authorId}.jpg` : Authorimage} className='img-fluid w-100' />
                                            </div>
                                            <div className='d-flex justify-content-between align-items-center flex-column'>
                                              <a href='#'> <IoLinkOutline className={parentsviewStyle.linkiconChain} /> </a>
                                              <Link
                                                to={authorId ? `/AuthorProfilePage/${authorId}` : "#"}
                                                className={parentsviewStyle.viewLink}
                                              >
                                                View Author Page
                                              </Link>
                                            </div>
                                          </div>
                                          <div className={parentsviewStyle.authorBios}>
                                            <h5> Bio </h5>
                                            <p> a whimsical children's author known for his enchanting tales that blend nature,
                                              adventure, and imagination. With a love for the outdoors and a knack for storytelling,
                                              Elliot creates stories that whisk young readers away to magical forests, talking animals,
                                              and brave young heroes. His most popular series, The Woodland Chronicles, follows the
                                              adventures of a young boy who discovers a hidden world of creatures living in the
                                              woods behind his house, each with their own story to tell.
                                            </p>
                                            <h5> Authors Note to Families </h5>
                                            <p> Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
                                              invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
                                              accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
                                              sanctus est Lorem ipsum dolor sit amet.
                                            </p>
                                          </div>
                                        </div>
                                        <div className={`${parentsviewStyle.authorsliderHead} d-flex align-items-center flex-wrap mb-4`}>
                                          <h4> Book List:{book.authorName} </h4>
                                          <p className='ms-auto'> <b className='me-2'> Order by date: </b> 00/00/0000 </p>
                                        </div>
                                        <div className='row'>
                                          <div className='col-lg-12'>
                                            <div className={parentsviewStyle.booksCaseWrapper}>
                                              <ul className={`${parentsviewStyle.bookBoxes} ${parentsviewStyle.columnsFive} p-0`}>
                                                {book.authorBookDataAdded
                                                  .flatMap(a => a.books)
                                                  .slice(0, showAllBooks ? undefined : 5) // 👈 key line
                                                  .map((aubooks, index) => (
                                                    <li key={index} className={parentsviewStyle.bookBoxesWrap}>
                                                      <div className={parentsviewStyle.bookcontentBlock}>
                                                        <div className={parentsviewStyle.bookblockImage}>
                                                          <img
                                                            src={`${process.env.REACT_APP_API_BASE_URL}authormeetapi/images/ProductImages/${aubooks.isbn}.jpg`}
                                                            width="600"
                                                            height="840"
                                                          />
                                                        </div>
                                                        <div className={`${parentsviewStyle.bookblockContent} mt-1`}>
                                                          <h5 className='text-start'>{aubooks.title}</h5>
                                                          <p className='text-start'>$ {aubooks.price}</p>
                                                        </div>
                                                      </div>
                                                    </li>
                                                  ))}
                                              </ul>
                                            </div>
                                          </div>
                                        </div>

                                        {/* SEE MORE / SEE LESS */}
                                        {book.authorBookDataAdded.flatMap(a => a.books).length > 5 && (
                                          <div className='row'>
                                            <div className='col-lg-12 text-center'>
                                              <button
                                                className="btn btn-link"
                                                onClick={() => setShowAllBooks(!showAllBooks)}
                                              >
                                                {showAllBooks ? "See Less" : "See More"}
                                              </button>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          )
                        ) : (
                          <div className={`${parentsviewStyle.alertBox} alert alert-danger d-flex align-items-center`} role="alert">
                            Data Are not Available
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

            </div>

            {isMobile ? (
              undefined
            ) : (
              <div className="col-xl-2">
                <div className='d-flex justify-content-center flex-column align-items-center h-100'>
                  <div className={parentsviewStyle.importantBox}>
                    <h5> <b> Important Info: </b> Order by date </h5>
                    <p> Please ensure your book orders are placed by the specified date to allow Bookworm Central
                      sufficient time to process and deliver them to the school.
                    </p>
                  </div>
                </div>
              </div>)}

          </div>
        </div>
      </div>
    </>
  )
}
